import { create } from 'zustand';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import React from 'react';

interface SupabaseStore {
	supabase: SupabaseClient;
	initialize: () => void;
}

const STORYBOOK_PLACEHOLDER_URL = 'https://storybook-placeholder.supabase.co';
const STORYBOOK_PLACEHOLDER_KEY = 'storybook-placeholder-anon-key';

const createDefaultClient = (): SupabaseClient => {
	const url =
		typeof window !== 'undefined' && import.meta.env.VITE_SUPABASE_URL
			? import.meta.env.VITE_SUPABASE_URL
			: STORYBOOK_PLACEHOLDER_URL;
	const key =
		typeof window !== 'undefined' && import.meta.env.VITE_SUPABASE_ANON_KEY
			? import.meta.env.VITE_SUPABASE_ANON_KEY
			: STORYBOOK_PLACEHOLDER_KEY;

	return createClient(url, key);
};

export const useSupabaseStore = create<SupabaseStore>((set) => ({
	supabase: createDefaultClient(),

	initialize: () => {
		const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
		const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

		if (!supabaseUrl || !supabaseKey) {
			console.error('Missing Supabase environment variables');
			return;
		}

		const supabase = createClient(supabaseUrl, supabaseKey);
		set({ supabase });
	}
}));

if (typeof window !== 'undefined') {
	useSupabaseStore.getState().initialize();
}

export const useSafeSupabase = () => {
	const { supabase, initialize } = useSupabaseStore();

	React.useEffect(() => {
		initialize();
	}, [initialize]);

	return supabase;
};
